import { render, staticRenderFns } from "./ReportConfigModal.vue?vue&type=template&id=9f28f46a&scoped=true"
import script from "./ReportConfigModal.vue?vue&type=script&lang=ts"
export * from "./ReportConfigModal.vue?vue&type=script&lang=ts"
import style0 from "./ReportConfigModal.vue?vue&type=style&index=0&id=9f28f46a&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f28f46a",
  null
  
)

export default component.exports